module.exports = __webpack_public_path__ + "static/media/a_default_kids_protesting.1e7fa69d.jpg";